const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  user: (state) => state.user,
  userRole: (state) => state.role,
  accessToken: (state) => state.tokens.access,
  refreshToken: (state) => state.tokens.refresh,
  authStatus: (state) => state.status,
  sessionRestored: (state) => state.sessionRestored,
  /**
   * Le mot de passe en place a ete envoye par un administrateur: la plateforme
   * n'ouvre rien d'autre que son remplacement, cote API comme cote navigation.
   */
  mustChangePassword: (state) => Boolean(state.user?.mustChangePassword),
  hasRole: (state) => (role) => state.role === role,
  hasAnyRole:
    (state) =>
    (roles = []) =>
      roles.includes(state.role),
};

export default getters;
